import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { SORT_OPTIONS } from "../constants/sortOptions";
import PropTypes from "prop-types";
import { useSortParam } from "../hooks/useSortParam";

const SortContext = createContext(null);

export const SortProvider = ({
	defaultSort = SORT_OPTIONS.RECOMMENDATION.id,
	options = SORT_OPTIONS,
	comparators = {},
	children,
}) => {
	const [isOpen, setIsOpen] = useState(false);

	const { sortBy, setSortBy } = useSortParam({ defaultValue: defaultSort, sortOptions: options });

	const openDrawer = useCallback(() => setIsOpen(true), []);
	const closeDrawer = useCallback(() => setIsOpen(false), []);

	const value = useMemo(
		() => ({
			isOpen,
			openDrawer,
			closeDrawer,
			sortBy,
			setSortBy,
			options,
			comparators,
		}),
		[isOpen, openDrawer, closeDrawer, sortBy, setSortBy, comparators]
	);

	return <SortContext.Provider value={value}>{children}</SortContext.Provider>;
};

SortProvider.propTypes = {
	defaultSort: PropTypes.string,
	options: PropTypes.object,
	children: PropTypes.node,
	comparators: PropTypes.object,
};

export const useSortContext = () => {
	const ctx = useContext(SortContext);

	if (!ctx) {
		throw new Error("useSortContext must be used within <SortProvider>");
	}

	return ctx;
};
